import { useTranslation } from 'react-i18next';
import { Menu, MenuHandler, MenuItem, MenuList } from '@material-tailwind/react';

import { supportedLngs } from '../../../../i18n/config';
import { useAppDispatch } from '../../../../state/hooks';
import { setLanguage } from '../../../../slices/local/user';
import { IconButton } from './UI';
import { TranslateIcon } from './Icons';

export const LanguageMenu = () => {
  const { i18n, t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleLanguageChange = async (language) => {
    dispatch(setLanguage({
      language
    }));

    await i18n.changeLanguage(language.key);
  };

  return (
    <Menu placement="bottom-end">
      <MenuHandler>
        <span>
          <IconButton title={t('musicstyling.nav.language')}>
            <TranslateIcon className="w-6 h-6" />
          </IconButton>
        </span>
      </MenuHandler>
      <MenuList className="min-w-36">
        {supportedLngs.map(language => (
          <MenuItem
            key={language.key}
            onClick={() => handleLanguageChange(language)}
            className={`flex items-center justify-between gap-4 ${i18n.resolvedLanguage === language.key ? 'text-ms-accent' : ''}`}
          >
            <span>{language.name}</span>
            <span className="text-xs uppercase text-ms-subtle">{language.key}</span>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
